module.exports = __webpack_public_path__ + "img/bank-bjb-logo.5cf8a5d7.jpg";